import React from 'react';

import { useRouter } from 'next/router';
import { FILTER_CODES } from '../constants';

const useFiltersReset = () => {
	const router = useRouter();

	const handleFiltersReset = React.useCallback(() => {
		const newQuery = Object.keys(router.query)
			.filter(
				(qk) =>
					![
						FILTER_CODES.COMMON,
						FILTER_CODES.PRICE,
						FILTER_CODES.SPEC,
						FILTER_CODES.CAPACITY,
						FILTER_CODES.DISTRICT,
					].includes(qk),
			)
			.reduce((acc, qk) => {
				acc[qk] = router.query[qk];
				return acc;
			}, {});

		router.push({ query: newQuery }, null, {
			shallow: true,
		});
	}, [router]);

	return { handleFiltersReset };
};

export default useFiltersReset;
